import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useIdleTimer } from "react-idle-timer";

export default function IdleHandler(props) {
  let history = useHistory();

  const [modalProcedureOpen, setModalProcedureOpen] = useState(false);

  // Never expire an idle session during local development, so long-running
  // automated sessions (loops, browser automation) stay logged in.
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname === "127.0.0.1";

  // Demo and staging carry only fake data, and demo is driven live in front of
  // an audience. An auto-logout mid-presentation costs more there than the idle
  // timer protects, so both get the same exemption as localhost. Production
  // (my.fairmarkethealth.com) and the branded broker demo still time out.
  const isNonProdHost =
    window.location.hostname === "demo-my.fairmarkethealth.com" ||
    window.location.hostname === "staging-my.fairmarkethealth.com";

  const skipIdleLogout = isLocalhost || isNonProdHost;

  // Restrict an idle session if the role is something
  // that may have access to larger amounts of PHI
  // Basically only the patient is allowed an idle session
  const onIdle = () => {
    if (skipIdleLogout) {
      return;
    }
    if (
      props.claims.default_role === "agent" ||
      props.claims.default_role === "provider" ||
      props.claims.default_role === "groupadmin" ||
      props.claims.default_role === "broker" ||
      props.claims.default_role === "employer" ||
      props.claims.default_role === "scheduler" ||
      props.claims.default_role === "agentold" // is this still used?
    ) {
      history.push("/sign-out");
    }
  };

  const onPrompt = () => {
    if (skipIdleLogout) {
      return;
    }
    if (
      props.claims.default_role === "agent" ||
      props.claims.default_role === "provider" ||
      props.claims.default_role === "groupadmin" ||
      props.claims.default_role === "broker" ||
      props.claims.default_role === "employer" ||
      props.claims.default_role === "scheduler" ||
      props.claims.default_role === "agentold" // is this still used?
    ) {
      setModalProcedureOpen(true);
    }
  };

  const numIdleMinutes = 10;
  const numPromptSeconds = 30;
  const idleTimer = useIdleTimer({
    onIdle,
    onPrompt,
    timeout: 1000 * 60 * numIdleMinutes,
    promptTimeout: 1000 * numPromptSeconds,
  });

  return (
    <>
      <Modal
        show={modalProcedureOpen}
        backdrop="static"
        onHide={() => {
          setModalProcedureOpen(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">Idle User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your session has been idle past the allowed idle session settings.
          Please click the Close button to continue, or you will be
          automatically logged out.
        </Modal.Body>
        <Modal.Footer>
          <div className="mr-auto float-left">
            <Button
              className="mr-1"
              variant="secondary"
              onClick={() => setModalProcedureOpen(false)}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
